var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#EB0029"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.566 6.75195C15.2599 6.82031 17.4223 9.02506 17.4225 11.7354V14.3877H18.8619V15.6348H17.4225V16.7002H18.8619V17.9473H17.4225V19.25H14.8219V17.9473H12.2809V16.7002H14.8219V15.6348H12.2809V14.3877H14.8219V11.7354C14.8217 10.4598 13.8198 9.41851 12.5602 9.35449L12.4371 9.35156H12.1237C10.807 9.35178 9.74004 10.4187 9.73987 11.7354V12.8691H7.13831V11.7354C7.13847 8.9821 9.37042 6.75022 12.1237 6.75H12.4371L12.566 6.75195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmd);
export default __webpack_public_path__ + "static/media/amd.feb782876754668d0f0accb9e56d4ce5.svg";
export { ForwardRef as ReactComponent };